import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { RadioInput, selectedBackground, selectedRadioButtonStyle, radioButtonStyle } from '../../components'

import AddressDisplay from './AddressDisplay'

import { AddressShape } from './propTypes'


const button = {
  marginTop: 0,
  marginBottom: 0,
  marginLeft: '5%',
  marginRight: '5%'
}

const button90Width = Object.assign({}, button, { width: '90%' });
const button40Width = Object.assign({}, button, { width: '40%' });

const r = {
  margin: 'auto',
  paddingTop: 7,
  paddingLeft: 10,
  paddingRight: 10,
  paddingBottom: 7
}

let ActiveAddressInAddressSelectorList = (
  {
    address,
    isSelected,
    onSelected,
    onRadioSelected,
    onBeginEdit,
    onDelete,
    selectAddressMessage,
    editable
  }) => (
    <div
      className='row'
      style={{ borderRadius: 4, borderWidth: 1, borderStyle: 'solid', borderColor: '#ddd' }}
    >
      <div className='col-xs-1' style={{ marginTop: 8, paddingLeft: 8 }}>
      <RadioInput selected={isSelected} onClick={() => onRadioSelected(address.Id)} />
      </div>
      <div className='col-xs-11'>
        <AddressDisplay address={address} compact={false} />
      </div>
      <div style={r}>
        <a
          href=''
          className='btn btn-info'
          onClick={(e) => e.preventDefault() || onSelected(address.Id)}
          style={button90Width}
        >
          {selectAddressMessage}
        </a>
      </div>
      {editable && (
        <div style={r}>
        
            <a href='' className='btn btn-default'
               onClick={(e) => e.preventDefault() || onBeginEdit(address.Id)}
               style={button40Width}
            >
              Edit
            </a>
        

          <a href='' className='btn btn-default'
            onClick={(e) => e.preventDefault() || onDelete(address.Id)}
            style={button40Width}
          >
            Delete
          </a>
        </div>)}
  </div>
)

ActiveAddressInAddressSelectorList.propTypes = {
  address: PropTypes.shape(AddressShape).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelected: PropTypes.func.isRequired,
  onRadioSelected: PropTypes.func.isRequired,
  onBeginEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  selectAddressMessage: PropTypes.string.isRequired,
  editable: PropTypes.bool.isRequired
}

export default ActiveAddressInAddressSelectorList